import { UrlPath } from '@helpers/util'

export const contactSupportUrl: UrlPath<any> = `support/contact`
